import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=7fac99ba&scoped=true&"
import script from "./addGoods.vue?vue&type=script&lang=js&"
export * from "./addGoods.vue?vue&type=script&lang=js&"
import style0 from "./addGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addGoods.vue?vue&type=style&index=1&id=7fac99ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac99ba",
  null
  
)

component.options.__file = "addGoods.vue"
export default component.exports